export type ReplenishmentColumnKey =
  | 'description'
  | 'organization'
  | 'location'
  | 'quantity_remaining'
  | 'actions';

export type ReplenishmentLocationRef = {
  code?: string;
  zoneId?: { color?: string; code?: string };
};

export type ReplenishmentLot = {
  _id?: string;
  lotNumber?: string;
  cartonAttributes?: { alias?: string };
  quantity?: { available?: number };
  location?: ReplenishmentLocationRef;
};

export type ReplenishmentItem = {
  _id?: string;
  productId?: {
    _id?: string;
    p_title?: string;
    p_sku?: string;
    p_images?: unknown;
    display_image?: unknown;
  };
  customerOrganizationId?: {
    company_name?: string;
    logo?: { url?: string };
  };
  locations?: Array<{
    locationId?: ReplenishmentLocationRef;
    inventoryIds?: ReplenishmentLot[];
  }>;
  currentQuantity?: number;
};

export type ReplenishmentLotRow = {
  item: ReplenishmentItem;
  lot: ReplenishmentLot;
  lotIndex: string;
};

export function getReplenishmentItemRowKey(item: ReplenishmentItem): string {
  return `item-${item._id ?? 'unknown'}`;
}

export function itemHasLots(item: ReplenishmentItem): boolean {
  return item.locations?.some(loc => (loc.inventoryIds?.length ?? 0) > 0) ?? false;
}

export function buildReplenishmentLotRows(
  item: ReplenishmentItem,
): ReplenishmentLotRow[] {
  const rows: ReplenishmentLotRow[] = [];
  item.locations?.forEach((loc, locIndex) => {
    loc.inventoryIds?.forEach((inv, invIndex) => {
      rows.push({
        item,
        lot: {
          ...inv,
          location: loc.locationId,
        },
        lotIndex: `${locIndex}-${invIndex}`,
      });
    });
  });
  return rows;
}

export function getReplenishmentLotRowKey(row: ReplenishmentLotRow): string {
  return `lot-${row.lot._id ?? `${row.item._id}-${row.lotIndex}`}`;
}
